class PrerenderManager {
    constructor() {
        this.pendingOperations = new Set(); // Start empty - components declare what they need
        this.timeout = 5000; // 5 seconds max wait
        this.startTime = Date.now();
        this.timeoutId = null;
        this.isReady = false;

        // Start timeout immediately
        this.startTimeout();
    }

    startTimeout() {
        this.timeoutId = setTimeout(() => {
            if (!this.isReady) {
                console.warn(
                    'PrerenderReady timeout - Still pending:',
                    Array.from(this.pendingOperations)
                );
                this.setReady(true); // Force ready even if not all operations completed
            }
        }, this.timeout);
    }

    // Components call this to declare which operations they need
    requireOperation(operation) {
        if (this.isReady) return; // Already complete, can't add operations

        if (!this.pendingOperations.has(operation)) {
            this.pendingOperations.add(operation);
            if (import.meta.env.MODE === 'development') {
                console.log(`⟳ ${operation} required - Now waiting for:`, Array.from(this.pendingOperations));
            }
        }
    }

    markReady(operation) {
        if (this.isReady) return; // Already fired

        this.pendingOperations.delete(operation);

        if (import.meta.env.MODE === 'development') {
            const elapsed = Date.now() - this.startTime;
            console.log(
                `✓ ${operation} ready (${elapsed}ms) - Still waiting for:`,
                Array.from(this.pendingOperations)
            );
        }

        if (this.pendingOperations.size === 0) {
            this.setReady();
        }
    }

    setReady(forced = false) {
        if (this.isReady) return;

        this.isReady = true;
        clearTimeout(this.timeoutId);

        const elapsed = Date.now() - this.startTime;
        if (import.meta.env.MODE === 'development') {
            console.log(
                forced
                    ? `⚠️ PrerenderReady forced after ${elapsed}ms timeout`
                    : `✓ All operations ready after ${elapsed}ms`
            );
        }

        window.prerenderReady = true;
    }
}

export default new PrerenderManager();
